import { IonButton, IonContent, IonPage } from '@ionic/react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';

const NotFound: React.FC = () => {
  const { t } = useTranslation();
  const history = useHistory();

  return (
    <IonPage>
      <IonContent>
        <div className="flex min-h-screen flex-col items-center justify-center bg-gradient-to-b from-white to-gray-100 px-4">
          <div className="relative mb-8">
            {/* 404 with stroke effect */}
            <h1 className="relative text-[10rem] font-extrabold leading-none tracking-tighter md:text-[12rem]">
              <span className="relative text-transparent bg-clip-text bg-white stroke-primary-500 stroke-2" style={{ WebkitTextStroke: '2px var(--ion-color-primary)' }}>404</span>
            </h1>
          </div>

          <div className="text-center z-10 max-w-md">
            <h2 className="text-2xl font-bold text-gray-800 mb-3">{t('page_not_found')}</h2>
            <p className="text-gray-600 mb-8">
              {t('page_not_found_description')}
            </p>

            <div className="flex justify-center">
              <IonButton
                onClick={() => history.goBack()}
                className="w-full max-w-xs font-medium rounded-full"
                expand="block"
                shape="round"
              >
                <span className="flex items-center justify-center">
                  {t('back')}
                </span>
              </IonButton>
            </div>
          </div>
        </div>
      </IonContent>
    </IonPage>
  );
};

export default NotFound;
